module.exports = __webpack_public_path__ + "media/application/images/process_steps/bookstack_01-dfc70c8ba7b3ea454889499c0398eb0f.png";